import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-pay-by-link',
  templateUrl: './pay-by-link.component.html',
})
export class PayByLinkResultComponent implements OnInit {
  constructor(public route: ActivatedRoute) {}

  status: any | null = null;
  transactionInfo: any | null = null;
  ngOnInit(): void {
    const info = localStorage.getItem('transaction') || '';
    this.status = this.route.snapshot.queryParams['status'];
    this.transactionInfo = JSON.parse(info);
  }
}
